<template>
  <!-- Лоадер вне лейаута: на весь экран, без шапки и футера — как в App.vue
       (.page-center берёт 100% высоты родителя, внутри лейаута он схлопывается) -->
  <div v-if="loading" class="page-center">
    <div class="page-center-box text-center">
      <Logo />
      <ui-loading-page class="mt-4" />
    </div>
  </div>

  <PublicLayout v-else>
      <div class="catalog-public__container">
        <div class="alert alert-info mt-4 mb-4">
          В каталоге собрана новая и&nbsp;изъятая техника, доступная
          в&nbsp;лизинг. Укажите марку, модель и&nbsp;модификацию&nbsp;&mdash;
          список обновится автоматически.
        </div>

        <!-- Сводка каталога (общие счётчики на момент загрузки) -->
        <div class="catalog-public__stats mb-4">
          <div>
            <strong>{{ stats.total }}</strong>
            <span>{{ pluralPositions(stats.total) }}</span>
          </div>
          <div>
            <strong>{{ stats.new }}</strong>
            <span>{{ pluralNew(stats.new) }}</span>
          </div>
          <div>
            <strong>{{ stats.used }}</strong>
            <span>{{ pluralUsed(stats.used) }}</span>
          </div>
        </div>

        <!-- Состояние: все / новая / изъятая (как в каталоге ЛК).
             Обёртка блочная: .catalog-tabs — inline-flex и иначе
             прилипает к сводке счётчиков в одну строку -->
        <div class="mb-4">
          <div class="catalog-tabs">
            <button
              v-for="tab in typeTabs"
              :key="tab.value"
              type="button"
              :class="typeFilter === tab.value && 'active'"
              @click="typeFilter = tab.value"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>

        <!-- Фильтры: марка / модель / модификация -->
        <div
          v-for="(row, index) in filterRows"
          :key="index"
          class="catalog-filter-row mb-3"
        >
          <!-- Колонка марки: при появлении «+» селект сужается, остальные колонки не сдвигаются -->
          <div class="catalog-brand-col">
            <div
              class="form-group form-floating catalog-select"
              :class="isHinted(index, 'brand') && 'catalog-select_hint'"
            >
              <select
                class="form-control form-select"
                v-model="row.brand"
                @change="onBrandChange(row)"
              >
                <option value="">Любая</option>
                <option v-for="brand in brands" :key="brand" :value="brand">
                  {{ brand }}
                </option>
              </select>
              <label>Марка</label>
            </div>

            <!-- Добавить ещё одну строку поиска (как на auto.ru) -->
            <button
              v-if="index === filterRows.length - 1 && row.brand"
              class="catalog-btn"
              type="button"
              title="Добавить марку"
              @click="addFilterRow"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M21 11h-8V3h-2v8H3v2h8v8h2v-8h8z"
                ></path>
              </svg>
            </button>
          </div>

          <div
            class="form-group form-floating catalog-select"
            :class="isHinted(index, 'model') && 'catalog-select_hint'"
            @click="!row.brand && flashHint(index, 'brand')"
          >
            <select
              class="form-control form-select"
              v-model="row.model"
              :disabled="!row.brand"
              @change="onModelChange(row)"
            >
              <option value="">Любая</option>
              <option
                v-for="model in modelsFor(row)"
                :key="model"
                :value="model"
              >
                {{ model }}
              </option>
            </select>
            <label>Модель</label>
          </div>

          <!-- Колонка модификации: «✕» всегда в одной строке с селектом -->
          <div class="catalog-mod-col">
            <div
              class="form-group form-floating catalog-select"
              @click="!row.model && flashHint(index, row.brand ? 'model' : 'brand')"
            >
              <select
                class="form-control form-select"
                v-model="row.modification"
                :disabled="!row.model"
              >
                <option value="">Любая</option>
                <option
                  v-for="mod in modificationsFor(row)"
                  :key="mod"
                  :value="mod"
                >
                  {{ mod }}
                </option>
              </select>
              <label>Модификация</label>
            </div>

            <!-- Удалить строку -->
            <button
              v-if="filterRows.length > 1 || row.brand"
              class="catalog-btn"
              type="button"
              title="Удалить"
              @click="removeFilterRow(index)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="m20.707 4.707-1.414-1.414L12 10.586 4.707 3.293 3.293 4.707 10.586 12l-7.293 7.293 1.414 1.414L12 13.414l7.293 7.293 1.414-1.414L13.414 12z"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="catalog-actions mb-4">
          <a
            v-if="hasActiveFilter"
            class="catalog-reset"
            href="javascript:void(0);"
            @click="resetFilters"
            >Сбросить
            <svg
              class="catalog-reset__cross"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m20.707 4.707-1.414-1.414L12 10.586 4.707 3.293 3.293 4.707 10.586 12l-7.293 7.293 1.414 1.414L12 13.414l7.293 7.293 1.414-1.414L13.414 12z"
              ></path>
            </svg>
          </a>
          <!-- white — спиннер загрузки на чёрной кнопке -->
          <ui-button
            class="catalog-show-btn"
            :loading="loadingShow"
            white
            @click="applyFilters"
            >Показать {{ shownCount }} {{ pluralOffers(shownCount) }}</ui-button
          >
        </div>

        <!-- якорь для скролла к списку по кнопке «Показать» -->
        <div ref="results"></div>

        <div
          v-if="showResults && noResults"
          class="position-relative no-list-data"
        >
          <ui-no-data-page text="По заданным условиям ничего не найдено" />
        </div>

        <!-- Списки: новая и изъятая техника раздельно, у каждой своя постраничная выдача -->
        <template v-if="showResults">
        <template v-for="group in visibleGroups">
          <div v-if="group.total" :key="group.key" class="mb-5">
            <h2 class="mt-4">
              {{ group.title }} ({{ group.total }}
              {{ pluralOffers(group.total) }})
            </h2>
            <div class="hr mt-2 mb-4"></div>
            <div class="row">
              <div
                v-for="item in group.items"
                :key="item.id"
                class="col-md-6 col-xl-4 mb-4 d-flex"
              >
                <div class="catalog-card">
                  <div class="catalog-card__img">
                    <img
                      v-if="item.image && item.loadingImg"
                      :src="item.image"
                      :alt="item.name"
                    />

                    <div
                      v-else-if="item.image"
                      class="h-100"
                      style="position: absolute; width: 100%"
                    >
                      <div class="page-center">
                        <div class="page-center-box text-center">
                          <ui-loading-page />
                        </div>
                      </div>
                    </div>

                    <span
                      class="catalog-card__badge"
                      :class="
                        item.type === 'Новая техника'
                          ? 'catalog-card__badge_new'
                          : 'catalog-card__badge_used'
                      "
                      >{{
                        item.type === "Новая техника"
                          ? "Новая техника"
                          : "Изъятая техника"
                      }}</span
                    >
                  </div>
                  <div class="catalog-card__body">
                    <div v-if="item.brand || item.model" class="catalog-card__crumbs">
                      {{ item.brand
                      }}<template v-if="item.brand && item.model"> &middot; </template>{{ item.model }}
                    </div>
                    <div class="catalog-card__title">{{ item.name }}</div>
                    <div v-if="item.modification" class="catalog-card__mod">{{ item.modification }}</div>
                    <div v-if="item.description" class="catalog-card__desc">{{ item.description }}</div>
                    <div class="mt-auto">
                      <div class="catalog-card__price-label">
                        Полная стоимость
                      </div>
                      <div class="catalog-card__price">
                        {{ priceMask(item.price) }}
                      </div>
                      <div class="catalog-card__footer">
                        <router-link
                          v-if="item.calc_id"
                          class="btn btn-base"
                          :to="{ path: '/ecp', query: { CalcID: item.calc_id } }"
                          target="_blank"
                          rel="noopener"
                        >
                          Оформить заявку
                        </router-link>
                        <button v-else class="btn btn-base" disabled>
                          Оформить заявку
                        </button>
                        <a
                          v-if="item.url"
                          class="catalog-card__supplier"
                          :href="item.url"
                          target="_blank"
                          rel="noopener"
                          ><!-- &#xFE0E; — текстовое начертание: без него iOS рисует стрелку эмодзи -->
                          Страница поставщика &nearr;&#xFE0E;</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="group.total > group.items.length"
              class="text-center mt-2"
            >
              <ui-button
                @click="getPage(group)"
                :loading="group.loadingPage"
                class="catalog-show-btn"
                white
                >Загрузить еще</ui-button
              >
            </div>
          </div>
        </template>
        </template>
      </div>
  </PublicLayout>
</template>

<script>
import { getCatalog, getCatalogInit, getCatalogSearch } from "./api";
import PublicLayout from "./PublicLayout.vue";
import Logo from "@/assets/svg/LogoLogin.vue";

const emptyRow = () => ({ brand: "", model: "", modification: "" });

// размер страницы серверной выдачи (кнопка «Загрузить еще»)
const PAGE_SIZE = 6;

export default {
  name: "catalog-public",
  components: { PublicLayout, Logo },
  data() {
    return {
      loading: true,
      // уникальные сочетания тип/марка/модель/модификация — для селектов фильтра
      combos: [],
      typeFilter: "all",
      typeTabs: [
        { value: "all", label: "Вся техника" },
        { value: "new", label: "Новая техника" },
        { value: "used", label: "Изъятая техника" },
      ],
      filterRows: [emptyRow()],
      // подсветка незаполненного селекта при клике по заблокированному
      hint: { index: null, field: null },
      hintTimer: null,
      // каталог показывается только после нажатия «Показать»
      showResults: false,
      loadingShow: false,
      // применённый фильтр: его же использует «Загрузить еще»
      appliedRows: [],
      // защита от гонки ответов при быстрой смене фильтра
      reloadToken: 0,
      // общие счётчики каталога на момент загрузки — сводка под заголовком
      stats: { total: 0, new: 0, used: 0 },
      // выдача по типам: у каждой группы свои страницы и своя кнопка подгрузки
      groups: {
        new: { key: "new", title: "Новая техника", items: [], total: 0, loadingPage: false },
        used: { key: "used", title: "Изъятая техника", items: [], total: 0, loadingPage: false },
      },
    };
  },
  computed: {
    // сочетания выбранной вкладки типа — в селектах только то, что реально есть в базе
    typeCombos() {
      if (this.typeFilter === "new")
        return this.combos.filter((combo) => combo.type === "Новая техника");
      if (this.typeFilter === "used")
        return this.combos.filter((combo) => combo.type !== "Новая техника");
      return this.combos;
    },
    brands() {
      return [...new Set(this.typeCombos.map((combo) => combo.brand))].sort(
        (a, b) => a.localeCompare(b, "ru")
      );
    },
    // «Сбросить» касается только строк фильтра, вкладка типа живёт отдельно
    hasActiveFilter() {
      return this.filterRows.some((row) => row.brand);
    },
    // число на кнопке «Показать» — по выбранной вкладке типа;
    // счётчики — это totals групп из последнего запроса выдачи
    shownCount() {
      if (this.typeFilter === "new") return this.groups.new.total;
      if (this.typeFilter === "used") return this.groups.used.total;
      return this.groups.new.total + this.groups.used.total;
    },
    // обе группы всегда загружены одним запросом, вкладка лишь выбирает, что показать
    visibleGroups() {
      if (this.typeFilter === "new") return [this.groups.new];
      if (this.typeFilter === "used") return [this.groups.used];
      return [this.groups.new, this.groups.used];
    },
    noResults() {
      return this.visibleGroups.every((group) => group.total === 0);
    },
  },
  watch: {
    filterRows: {
      deep: true,
      handler() {
        this.autoApply();
      },
    },
    // у типов разные наборы марок/моделей, поэтому смена вкладки очищает фильтр;
    // если фильтр и так был пуст, запроса не будет — обе группы уже загружены,
    // вкладка лишь переключает видимость
    typeFilter() {
      this.filterRows = [emptyRow()];
    },
  },
  methods: {
    modelsFor(row) {
      return [
        ...new Set(
          this.typeCombos
            .filter((combo) => combo.brand === row.brand)
            .map((combo) => combo.model)
        ),
      ].sort((a, b) => a.localeCompare(b, "ru"));
    },
    modificationsFor(row) {
      return [
        ...new Set(
          this.typeCombos
            .filter(
              (combo) => combo.brand === row.brand && combo.model === row.model
            )
            .map((combo) => combo.modification)
        ),
      ].sort((a, b) => a.localeCompare(b, "ru"));
    },
    onBrandChange(row) {
      row.model = "";
      row.modification = "";
    },
    onModelChange(row) {
      row.modification = "";
    },
    addFilterRow() {
      this.filterRows.push(emptyRow());
    },
    removeFilterRow(index) {
      this.filterRows.splice(index, 1);
      if (this.filterRows.length === 0) this.filterRows.push(emptyRow());
    },
    // строки фильтра с выбранной маркой — в формате rows для API
    activeRows() {
      return this.filterRows
        .filter((row) => row.brand)
        .map((row) => ({
          brand: row.brand,
          model: row.model,
          modification: row.modification,
        }));
    },
    prepareItems(list) {
      return list.map((item) => ({ ...item, loadingImg: !item.image }));
    },
    // предзагрузка картинок: loadingImg = true, когда изображение готово к показу.
    // Вызывается после вставки в data: мутировать нужно реактивные объекты,
    // иначе Vue (Proxy) не заметит смену loadingImg и спиннер не пропадёт
    preloadImages(items) {
      items.forEach((item) => {
        if (!item.image || item.loadingImg) return;
        const img = new Image();
        img.onload = () => {
          item.loadingImg = true;
        };
        // не загрузилась — карточка остаётся с фоном, без вечного спиннера
        img.onerror = () => {
          item.image = "";
          item.loadingImg = true;
        };
        img.src = item.image;
      });
    },
    // первая страница группы из ответа сервера (init или search)
    applyGroup(group, data) {
      group.total = data.total;
      group.items = this.prepareItems(data.data);
      this.preloadImages(group.items);
    },
    // «Загрузить еще»: единственное место, где группа запрашивается отдельно
    async getPage(group) {
      group.loadingPage = true;
      const response = await getCatalog({
        type: group.key,
        rows: this.appliedRows,
        limit: PAGE_SIZE,
        offset: group.items.length,
      });
      if (response.status) {
        group.total = response.total;
        group.items = [...group.items, ...this.prepareItems(response.data)];
        this.preloadImages(group.items);
      }
      group.loadingPage = false;
    },
    // обе группы и счётчики текущего фильтра одним запросом;
    // на время загрузки — спиннер на «Показать»
    async reloadGroups() {
      const token = ++this.reloadToken;
      this.loadingShow = true;
      const response = await getCatalogSearch(this.appliedRows, PAGE_SIZE);
      // ответ устаревшего запроса — фильтр уже сменился, выдачу не трогаем
      if (token !== this.reloadToken) return;
      if (response.status) {
        this.applyGroup(this.groups.new, response.new);
        this.applyGroup(this.groups.used, response.used);
      }
      this.loadingShow = false;
      this.showResults = true;
    },
    // применяет текущий фильтр и обновляет выдачу; ничего не делает,
    // если фильтр не менялся с прошлого применения
    async autoApply() {
      const rows = this.activeRows();
      if (JSON.stringify(rows) === JSON.stringify(this.appliedRows)) return;
      this.appliedRows = rows;
      await this.reloadGroups();
    },
    // кнопка «Показать»: выдача уже обновлена автоматически — скроллим к ней
    async applyFilters() {
      await this.autoApply();
      await this.$nextTick();
      // останавливаемся выше якоря на величину mt-4 (1.5rem), чтобы отступ заголовка был виден
      const offset = 24;
      const top =
        this.$refs.results.getBoundingClientRect().top +
        window.pageYOffset -
        offset;
      window.scrollTo({ top, behavior: "smooth" });
    },
    // очищает только строки фильтра — выбранная вкладка типа сохраняется
    async resetFilters() {
      this.filterRows = [emptyRow()];
      await this.autoApply();
    },
    isHinted(index, field) {
      return this.hint.index === index && this.hint.field === field;
    },
    flashHint(index, field) {
      clearTimeout(this.hintTimer);
      this.hint = { index, field };
      this.hintTimer = setTimeout(() => {
        this.hint = { index: null, field: null };
      }, 2000);
    },
    pluralOffers(count) {
      const mod10 = count % 10;
      const mod100 = count % 100;
      if (mod10 === 1 && mod100 !== 11) return "предложение";
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return "предложения";
      return "предложений";
    },
    pluralPositions(count) {
      const mod10 = count % 10;
      const mod100 = count % 100;
      if (mod10 === 1 && mod100 !== 11) return "позиция";
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return "позиции";
      return "позиций";
    },
    pluralNew(count) {
      const mod10 = count % 10;
      const mod100 = count % 100;
      if (mod10 === 1 && mod100 !== 11) return "новая техника";
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return "новые техники";
      return "новых техник";
    },
    pluralUsed(count) {
      const mod10 = count % 10;
      const mod100 = count % 100;
      if (mod10 === 1 && mod100 !== 11) return "изъятая техника";
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return "изъятые техники";
      return "изъятых техник";
    },
    priceMask(value) {
      return value ? value.toLocaleString("ru-RU") + " ₽" : "Цена по запросу";
    },
  },
  // компонент в keep-alive: mounted не срабатывает при возврате с формы заявки,
  // а заголовок вкладки нужно вернуть
  activated() {
    document.title = "Подбор предмета лизинга - STONE-XXI";
  },
  async mounted() {
    document.title = "Подбор предмета лизинга - STONE-XXI";
    // при заходе фильтр пуст — весь первый экран одним запросом
    const response = await getCatalogInit(PAGE_SIZE);
    if (response.status) {
      this.combos = response.filters;
      this.applyGroup(this.groups.new, response.new);
      this.applyGroup(this.groups.used, response.used);
      this.stats = {
        total: response.new.total + response.used.total,
        new: response.new.total,
        used: response.used.total,
      };
    }
    this.showResults = true;
    this.loading = false;
  },
};
</script>
